import React from "react";
import { API_URL } from "../../constants/api";
import { SECTIONS } from "../../constants/appConstants";
import { IsTenant } from "../../utils/helper";
import { apiBatchRequest } from "../../utils/api_service";
import "./tenants.less";
import TenantTable from "./tenantsTable";
import AddUpdateTenant from "./addUpdateTenant";

class Tenants extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddDialogOpen: false,
      isChangedDC: false,
      toolTipData: []
    };
  }

  componentWillMount() {}

  /**
   * fetch list data
   */
  componentDidMount() {
    this.getMasterData();
  }

  /**
   * get the master data of tooltip
   */
  getMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: SECTIONS.ADD_UPDATE_TENANT },
        key: "toolTipData"
      }
    ]).then(({ toolTipData }) => {
      this.setState({
        toolTipData: toolTipData.data || []
      });
    });
  };

  /**
   * call on open add dialog
   * @param {*} isOpen
   */
  openAddDialog = (isOpen = true) => {
    this.setState({ isAddDialogOpen: isOpen });
  };

  /**
   * refresh tenant
   * @param {*} isTenantSaved
   */
  refreshTenants = (isTenantSaved = false) => {
    this.setState({ isTenantSaved: isTenantSaved });
    this.openAddDialog(false);
  };

  render() {
    // const TenantListing = IsSectionVisible(
    //   SECTIONS.TENANT,
    //   SECTIONS.TENANT_LISTING
    // );

    const {
      isAddDialogOpen,
      toolTipData,
      isChangedDC,
      startDate,
      endDate,
      isTenantSaved
    } = this.state;
    const isTenant = IsTenant();
    const { history } = this.props;
    return (
      <div className={"tenants-body-wrapper"}>
        {isAddDialogOpen && (
          <AddUpdateTenant
            isOpen={isAddDialogOpen}
            onClose={this.openAddDialog}
            onSave={this.refreshTenants}
            tenantId={0}
            history={history}
            toolTipData={toolTipData}
          />
        )}
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <div className={"tenants-wrapper"}>
              <div className={"tenants-breadcrumb-wrapper"}>
                <span className={"tenants-breadcrumb"}>{"HOME | Tenants"}</span>
              </div>
            </div>
          </div>
        </div>
        <div className={"row tenant-table"}>
          <TenantTable
            isTenant={isTenant}
            openAddDialog={this.openAddDialog}
            isChangedDC={isChangedDC}
            startDate={startDate}
            endDate={endDate}
            isTenantSaved={isTenantSaved}
          />
        </div>
      </div>
    );
  }
}
export default Tenants;
